import { Injectable } from "@angular/core";
import gql from "graphql-tag";
import {
  DeleteCertifiedPlantMutation,
  PlantMyUserInput,
  UpdatePlantSettingsInCertifiedPlantInput,
  UpdatePlantSettingsInCertifiedPlantMutation,
  UpdateUserInCertifiedPlantMutation,
  UpdateUsersInCertifiedPlantInput,
  UpdateUsersInCertifiedPlantMutation,
} from "ngx-core-services";

const updateSettingsFragment = gql`
fragment certifiedplanttype on CertifiedPlantType {
    success
    statusCode
    message
}
`;

@Injectable({
    providedIn: 'root'
})
export class SettingsAwsService {
    constructor(
      private readonly updatePlantSettingsInCertifiedPlantMutation: UpdatePlantSettingsInCertifiedPlantMutation,
      private readonly updateUserInCertifiedPlantMutation: UpdateUserInCertifiedPlantMutation,
      private readonly deleteCertifiedPlantMutation: DeleteCertifiedPlantMutation,
      private readonly updateUsersInCertifiedPlantMutation: UpdateUsersInCertifiedPlantMutation,
    ) { }

    async updateSystemSettings(updatePlantSettingsInCertifiedPlantInput: UpdatePlantSettingsInCertifiedPlantInput) {
      return await this.updatePlantSettingsInCertifiedPlantMutation.execute(updateSettingsFragment, updatePlantSettingsInCertifiedPlantInput);
    }

    async updateUsersInSystem(updateUsersInCertifiedPlantInput: UpdateUsersInCertifiedPlantInput) {
      return await this.updateUsersInCertifiedPlantMutation.execute(updateSettingsFragment, updateUsersInCertifiedPlantInput);
    }

    async removeUserFromSystem(userInput: PlantMyUserInput, plantId: string) {
      return await this.updateUserInCertifiedPlantMutation.execute(updateSettingsFragment, { plantId, user: userInput, remove: true });
    }

    async deleteSystem(plantId: string) {
      return await this.deleteCertifiedPlantMutation.execute(updateSettingsFragment, { plantId });
    }
}
